import Button from '@ixigo/iui/Button';
import cn from '@repo/shared/utils/cn';
import { Fragment, useState } from 'react';
import { NavigationHeader } from '@/components';
import type { CancellationSuccessResponse } from '../../-api';
import type { CancellationReason } from '../../-api/cancellation';
import { CancellationConfirmation } from './confirm-cancellation';
import { ReasonSelection } from './reason-selection';

interface CancellationFlowProps {
	cancellationInfo: CancellationSuccessResponse['data'];
	selectedReason: CancellationReason | null;
	onSelectionChange: (reason: CancellationReason) => void;
	onClose: () => void;
	onConfirm: () => void;
}

export const CancellationFlow = ({
	cancellationInfo,
	onClose,
	onConfirm,
	selectedReason,
	onSelectionChange,
}: CancellationFlowProps) => {
	const [navigationStep, setNavigationStep] = useState<
		'reason-selection' | 'confirmation'
	>('reason-selection');

	const handleNavigation = () => {
		switch (navigationStep) {
			case 'reason-selection':
				onClose();
				break;
			case 'confirmation':
				setNavigationStep('reason-selection');
				break;
		}
	};
	const handleSubmit = () => {
		if (navigationStep === 'reason-selection') {
			setNavigationStep('confirmation');
			return;
		}
		onConfirm();
	};
	const btnText =
		navigationStep === 'confirmation'
			? !cancellationInfo.cancellationCharges.applicable
				? 'Proceed With Cancellation'
				: 'Confirm Cancellation'
			: 'Submit';

	return (
		<Fragment>
			<NavigationHeader
				title="Reason for Cancellation"
				leftAction={handleNavigation}
				className={cn(
					'border-b border-tertiary',
					navigationStep === 'confirmation' && 'hidden',
				)}
			/>
			<div
				className="bg-primary px-20 py-15"
				style={{ viewTransitionName: 'cancellation-detail' }}
			>
				{navigationStep === 'reason-selection' ? (
					<ReasonSelection
						cancellationReasons={cancellationInfo.reasons}
						selectedReason={selectedReason}
						onChange={(reason) => onSelectionChange(reason)}
					/>
				) : (
					<CancellationConfirmation
						onClose={onClose}
						cancellationMetainfo={cancellationInfo.cancellationCharges.metaInfo}
					/>
				)}
			</div>
			<div className="bg-primary border-t border-tertiary px-20 py-2.5">
				<Button
					onClick={() => handleSubmit()}
					disabled={!selectedReason}
					className="w-full"
					size="lg"
				>
					{btnText}
				</Button>
			</div>
		</Fragment>
	);
};
